import PropTypes from 'prop-types'; // eslint-disable-next-line import/prefer-default-export

export const SpaceType = PropTypes.shape({
  id: PropTypes.string,
  avatar: PropTypes.string,
  code: PropTypes.string,
  name: PropTypes.string
});
//# sourceMappingURL=propTypes.js.map